import { action, observable } from 'mobx';
import Relation from './Relation';

/**
 * Связь BelonsTo
 * Пример: task.project - задача принадлежит проекту
 */
export default class BelongsTo extends Relation {

	@observable _cache;

	constructor (model, targetModel, relation, instance) {
		super (model, targetModel, relation, instance);
	}

	/**
	 * Возвращает связанный объект, возвращает промис
	 * @param {Model} instance Объект к которому запрашивается связь
	 */
	get () {
		if (this._cache === undefined) {
			let foreignId = this._instance[this._relation.foreignKey];
			// проверяем на undefined и null, так как значение может быть === 0
			this._cache = foreignId !== undefined && foreignId !== null ?
				(
					this._relation.keyTo ?
						this._targetModel.findOne({where: {[this._relation.keyTo]: foreignId}}) :
						this._targetModel.findById(foreignId)
				)
				:
				null;

		}

		// Если имеем дело с промисом, то после его завершения записываем в кеш результат
		if (this._cache && typeof this._cache === 'object' && typeof this._cache.then === 'function') {
			this._cache.then((value) => {
				this._cache = value;
			});
		}

		return this._cache;
	};

	/**
	 * Устанавливает связанный объект, запрос на сервер не идет
	 */
	set (instance) {
		this._cache = this._targetModel.PROCESS_INSTANCE_CACHE(instance);
		this._instance [this._relation.foreignKey] = instance ? instance.id : null;
	};

	/**
	 * Очистка кэша, нужно при получении данных без include
	 */
	clearCache (value) {
		this._cache = value;
	}
}
